import { Check } from "lucide-react";

const POINTS = [
  "One trusted point of contact for all your IT",
  "Clear, jargon-free advice you can act on",
  "Fast response for home and business users",
  "Microsoft 365 specialists",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-[#F4F4F5] border-y-2 border-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <img
            data-testid="about-image"
            src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80"
            alt="Small business team at work"
            className="w-full h-[420px] object-cover border-2 border-black grayscale contrast-110"
          />
          <div className="absolute -bottom-5 -right-5 bg-[#E60000] text-white border-2 border-black px-6 py-4 hidden sm:block">
            <span className="font-heading font-black text-2xl block leading-none">10+</span>
            <span className="font-heading font-bold uppercase text-xs tracking-widest">Core services</span>
          </div>
        </div>

        <div>
          <span className="font-heading font-bold uppercase text-sm tracking-widest text-[#E60000]">
            Why StottTech
          </span>
          <h2 className="font-heading font-black uppercase tracking-tight text-3xl md:text-5xl mt-3 mb-6">
            IT support that speaks your language
          </h2>
          <p className="text-lg text-black/70 leading-relaxed mb-8">
            StottTech is a UK-based IT support service built for small businesses.
            Whether you're moving to Microsoft 365, securing your accounts, or just
            need a printer to behave, we deliver practical solutions, reliable support
            and the outcomes that help your business succeed.
          </p>
          <ul className="space-y-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 h-6 w-6 flex-shrink-0 flex items-center justify-center bg-black text-white">
                  <Check className="h-4 w-4" strokeWidth={3} />
                </span>
                <span className="font-medium">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
